/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React, { createRef, useState } from 'react';

import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./reset.css"
import "./layout.css"

const Layout = ({ children }) => {
  const [scrollTop, setScrollTop] = useState(0);
  const myRef = React.createRef();


  const handleScroll = (e) => {

    console.log(e)
    console.log('scrolling')
    // let myScrollTop = myRef.current.scrollTop


    // setScrollTop(e)
  }
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} onScroll={handleScroll} />

      <main style={{
        marginTop: `8rem`,
        height: '88vh'
      }} onScroll={handleScroll}> {children}</main>


    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
